import {
    FETCH_BENCHMARK_EXERCISES_DATA_FETCHING,
    FETCH_BENCHMARK_EXERCISES_DATA_SUCCESS,
    FETCH_BENCHMARK_EXERCISES_DATA_FAIL,
    SAVE_BENCHMARK_EXERCISE_DATA_START,
    SAVE_BENCHMARK_EXERCISE_DATA_SUCCESS,
    SAVE_BENCHMARK_EXERCISE_DATA_FAIL,
    UPDATE_BENCHMARK_EXERCISE_DATA_START,
    UPDATE_BENCHMARK_EXERCISE_DATA_SUCCESS,
    UPDATE_BENCHMARK_EXERCISE_DATA_FAIL,
    DELETE_BENCHMARK_EXERCISE_DATA_DELETING,
    DELETE_BENCHMARK_EXERCISE_DATA_SUCCESS,
    DELETE_BENCHMARK_EXERCISE_DATA_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    benchmarkExercisesData: [],
    benchmarkExercisesDataFetching: false,
    benchmarkExercisesDataSuccess: false,
    benchmarkExercisesDataFail: false,
    benchmarkExerciseDataSaving: false,
    benchmarkExerciseDataSaveSuccess: false,
    benchmarkExerciseDataSaveFail: false,
    benchmarkExerciseDataUpdating: false,
    benchmarkExerciseDataUpdateSuccess: false,
    benchmarkExerciseDataUpdateFail: false,
    benchmarkExerciseDataDeleting: false,
    benchmarkExerciseDataDeleteSuccess: false,
    benchmarkExerciseDataDeleteFail: false
};

const benchmarkExercisesDataFetching = (state) => ({
    ...state,
    benchmarkExercisesDataFetching: true
});

const benchmarkExercisesDataFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        benchmarkExercisesData: isSuccess ? action.benchmarkExercisesData : [],
        benchmarkExercisesDataFetching: false,
        benchmarkExercisesDataSuccess: isSuccess,
        benchmarkExercisesDataFail: !isSuccess
    };
};

const benchmarkExerciseDataSaving = (state) => ({
    ...state,
    benchmarkExerciseDataSaving: true
});

const benchmarkExerciseDataSaveFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        benchmarkExerciseDataSaving: false,
        benchmarkExerciseDataSaveSuccess: isSuccess,
        benchmarkExerciseDataSaveFail: !isSuccess
    };
};

const benchmarkExerciseDataUpdating = (state) => ({
    ...state,
    benchmarkExerciseDataUpdating: true
});

const benchmarkExerciseDataUpdateFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        benchmarkExerciseDataUpdating: false,
        benchmarkExerciseDataUpdateSuccess: isSuccess,
        benchmarkExerciseDataUpdateFail: !isSuccess
    };
};

const benchmarkExerciseDataDeleting = (state) => ({
    ...state,
    benchmarkExerciseDataDeleting: true
});

const benchmarkExerciseDataDeleteFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        benchmarkExerciseDataDeleting: false,
        benchmarkExerciseDataDeleteSuccess: isSuccess,
        benchmarkExerciseDataDeleteFail: !isSuccess,
        benchmarkExerciseDataUpdateSuccess: false,
        benchmarkExerciseDataSaveSuccess: false
    };
};

export const isBenchmarkExercisesDataFetching = (state) => {
    return state.benchmarkExercises.benchmarkExercisesDataFetching;
};

export const isBenchmarkExercisesDataFetchSuccess = (state) => {
    return state.benchmarkExercises.benchmarkExercisesDataSuccess;
};

export const isBenchmarkExercisesDataFetchFail = (state) => {
    return state.benchmarkExercises.benchmarkExercisesDataFail;
};

export const isBenchmarkExerciseDataSaving = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataSaving;
};

export const isBenchmarkExerciseDataSaveSuccess = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataSaveSuccess;
};

export const isBenchmarkExerciseDataSaveFail = (state) => {
    return state.benchmarkExercises.isBenchmarkExerciseDataSaveFail;
};

export const isBenchmarkExerciseDataUpdating = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataUpdating;
};

export const isBenchmarkExerciseDataUpdateSuccess = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataUpdateSuccess;
};

export const isBenchmarkExerciseDataUpdateFail = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataUpdateFail;
};

export const isBenchmarkExerciseDataDeleting = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataDeleting;
};

export const isBenchmarkExerciseDataDeleteSuccess = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataDeleteSuccess;
};

export const isBecnhmarkExerciseDataDeleteFail = (state) => {
    return state.benchmarkExercises.benchmarkExerciseDataDeleteFail;
};

export const getBenchmarkExercisesData = (state) => {
    return state.benchmarkExercises.benchmarkExercisesData;
};

export const getBenchmarkExerciseData = (state, exerciseKey) => {
    return state.benchmarkExercises.benchmarkExercisesData.find(({ benchmarkKey }) => benchmarkKey === exerciseKey);
};

const handlers = {
    [FETCH_BENCHMARK_EXERCISES_DATA_FETCHING]: benchmarkExercisesDataFetching,
    [FETCH_BENCHMARK_EXERCISES_DATA_SUCCESS]: benchmarkExercisesDataFetchFinished(true),
    [FETCH_BENCHMARK_EXERCISES_DATA_FAIL]: benchmarkExercisesDataFetchFinished(false),
    [SAVE_BENCHMARK_EXERCISE_DATA_START]: benchmarkExerciseDataSaving,
    [SAVE_BENCHMARK_EXERCISE_DATA_SUCCESS]: benchmarkExerciseDataSaveFinished(true),
    [SAVE_BENCHMARK_EXERCISE_DATA_FAIL]: benchmarkExerciseDataSaveFinished(false),
    [UPDATE_BENCHMARK_EXERCISE_DATA_START]: benchmarkExerciseDataUpdating,
    [UPDATE_BENCHMARK_EXERCISE_DATA_SUCCESS]: benchmarkExerciseDataUpdateFinished(true),
    [UPDATE_BENCHMARK_EXERCISE_DATA_FAIL]: benchmarkExerciseDataUpdateFinished(false),
    [DELETE_BENCHMARK_EXERCISE_DATA_DELETING]: benchmarkExerciseDataDeleting,
    [DELETE_BENCHMARK_EXERCISE_DATA_SUCCESS]: benchmarkExerciseDataDeleteFinished(true),
    [DELETE_BENCHMARK_EXERCISE_DATA_FAIL]: benchmarkExerciseDataDeleteFinished(false)
};

export default function benchmarkExercises(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
